import CacheBase2 from '../../../../services/engines/CacheBase2';

const _name = 'TopicGroupSearchCache';

class TopicGroupSearchCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns all cached results for a given service scope.
     * @param {string} service
     * @returns {object[]}
     */
    getByService = (service) => {
        try {
            return this._items.filter((i) => i.service === service);
        } catch (error) {
            this.logError('getByService', error.message);
            return [];
        }
    };
}

const topicGroupSearchCache = new TopicGroupSearchCache();
export default topicGroupSearchCache;
